<template>
  <div class="dev_period_simulator">
    
    <div class="container">
      <div class="row">
        <div class="col-12">
          
          <h6>(DEV) Simulate Period</h6>

          <b-form-select
          v-model="instance_period"
          :options="instance_period_options"
          @input="change_period"
          ></b-form-select>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'dev_period_simulator',
  props: [
    
  ],
  data () {
    return {
      instance_period_options: [
        {
          text: 'Event not started',
          value: 'Event not started'
        },
        {
          text: 'Nomination Period',
          value: 'Nomination Period'
        },
        {
          text: 'Nomination Intermission',
          value: 'Nomination Intermission'
        },
        {
          text: 'Voting Period',
          value: 'Voting Period'
        },
        {
          text: 'Voting Intermission',
          value: 'Voting Intermission'
        },
        {
          text: 'Winners Period',
          value: 'Winners Period'
        },
        {
          text: 'Event has ended',
          value: 'Event has ended'
        }
      ]
    }
  },
  computed: {
    instance_period: {
      get: function() {
        return this.$root.store.instances.get_current_active_instance_period();
      },
      set: function(value) {
        this.$root.store.instances.set_active_instance_period(value);
      }
    }
  },
  methods: {
    change_period: function(new_period) {
      this.instance_period = new_period;
    }
  },
  components: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.dev_period_simulator {
  margin-bottom: 2em;
}
</style>


// WEBPACK FOOTER //
// src/components/dev_tools/dev_period_simulator.vue